import {CanMatchFn, Router, UrlTree} from '@angular/router';
import {inject} from '@angular/core';
import {KeycloakService} from './keycloak.service';

export const IsNotAuthenticated: CanMatchFn = (): boolean | UrlTree => {
    const kc = inject(KeycloakService);
    const router = inject(Router);

    if (kc.isLoggedIn) {
        return router.parseUrl('/');
    }

    return true;
};
